/**
 * Created by lzy 
 * 百家号渠道服务模块
 */
'use strict';
angular.module('productManageMentBaijiahaoServiceModule', [
    'productManageMentBaijiahaoAccountAddModule', 
    'productManageMentEditBaijiahaoModule',
    'productManageMentSortBaijiahaoModule'
]).factory('productManageMentBaijiahaoService', ['$q', '$modal', 'trsHttpService', 'globleParamsSet', 
    function($q, $modal, trsHttpService, globleParamsSet) {
        return {

            /**
             * [getRight description]获取微博操作权限
             * @return object [description]
             */
            getRight: function(AccountId, classify) {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyOftrill',
                    AccountId: AccountId,
                    Classify: classify
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                    .then(function(data) {
                        var right = {};
                        for (var i = 0; i < data.length; i++) {
                            right[data[i].OPERNAME.split('.')[2]] = true;
                        }
                        deffer.resolve(right);
                    });
                return deffer.promise;
            },

            /**
             * [AccountAdd description] 添加或编辑百家号账号
             * @param {[type]} success [description]
             */
            AccountAdd: function(item, success) {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/productManageMent/baijiahao/service/baijiahaoAccountAdd/baijiahaoAccountAdd_tpl.html',
                    windowClass: 'weibo-account-add',
                    backdrop: false,
                    resolve: {
                        item: function() {
                            return item;
                        }
                    },
                    controller: 'ProductManageMentBaijiahaoAccountAddCtrl'
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [edit description] 修改微博配置
             * @return {[type]} [description]
             */
            edit: function(item, success) {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/productManageMent/baijiahao/service/editBaijiahao/editBaijiahao_tpl.html',
                    windowClass: 'weibo-account-add',
                    backdrop: false,
                    resolve: {
                        item: function() {
                            return item;
                        }
                    },
                    controller: 'productManageMentEditBaijiahaoCtrl'
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [sort description] 微博账号排序
             * @param  {[object]} item    [description] 微博账号
             * @param  {[Function]} success [description] 成功后的回调函数
             * @return {[type]}         [description]
             */
            sort: function(item, success) {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/productManageMent/baijiahao/service/sortBaijiahao/sortBaijiahao_tpl.html',
                    windowClass: 'productManageMent-weibo-sort',
                    backdrop: false,
                    resolve: {
                        item: function() {
                            return item;
                        }
                    },
                    controller: 'productManageMentSortBaijiahaoCtrl'
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            }
        };
    }]);
